import { Seo } from "components/Seo";
import { AccountState } from "context/AccountContext";
import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { companyService } from "services/Services";
import { UrlPath } from "utility/routes";

const MAX_ORGNR_LENGTH = 9

const AddCompany = () => {
  const navigate = useNavigate();
  const { stateAccount } = AccountState();

  const [orgNr, setOrgNr] = useState("");
  const [companyOptions, setCompanyOptions] = useState<Company[]>([]);
  const [currentCompany, setCurrentCompany] = useState<Company>();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [disableInput, setDisableInput] = useState(false);
  const [errorMessaage, setErrorMessage] = useState("");

  const isSumbitDisabled = !currentCompany || loadingSearch || loadingSubmit;

  const handleOrgNrChange = async(e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, MAX_ORGNR_LENGTH);
    setOrgNr(value);
    setErrorMessage("");
    setCurrentCompany(undefined);
    setCompanyOptions([]);

    if(value.length === MAX_ORGNR_LENGTH) {
      setDisableInput(true);
      setLoadingSearch(true);

      const response = await companyService.getCompanyByOrgNumber(value);
      const companies = response?.companies || [];

      if(companies.length === 0) {
        setErrorMessage("Fant ingen bedrift med dette organisasjonsnummeret.");
      } else {
        setCompanyOptions(companies);
        if(companies.length === 1) {
          setCurrentCompany(companies[0]);
        }
      }

      setLoadingSearch(false);
      setDisableInput(false);
    }
  }

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedCompany = companyOptions.find(x => x.id === e.target.value);
    setCurrentCompany(selectedCompany);
  }

  const handleSubmit = async (e:React.FormEvent) => {
    e.preventDefault();
    if(!currentCompany) return;

    setLoadingSubmit(true);
    await stateAccount.addCompany(currentCompany);
  }

  useEffect(() => {
    if(loadingSubmit && currentCompany) {
      navigate(UrlPath.MyAccount.Home);
    }
  }, [stateAccount.companies, loadingSubmit, navigate, currentCompany])

  return (
    <><Seo title="Legg til bedrift" />
      <div className="card">
        <div className="card-body">
          <form id="addCompanyForm" className="needs-validation" onSubmit={handleSubmit} noValidate>
            <h1 className="h3">Velg din bedrift</h1>
            <div className="mb-3">
              <label htmlFor="orgNr" className="form-label">
                Organisasjonsnummer
              </label>
              <input 
                type="number" 
                disabled={disableInput} 
                onChange={handleOrgNrChange} 
                className="form-control" 
                id="orgNr" 
                name="orgNr" 
                value={orgNr} 
                maxLength={9}
                required />
            </div>

            {errorMessaage && (
              <div className="alert alert-warning">{errorMessaage}</div>
            )}

            {companyOptions.length > 19  &&(
              <p className="mt-4 mb-4 fw-medium">
                Vi har mange treff på dette organisasjonsnummeret og viser et begrenset utvalg, <a rel="noreferrer" href="https://kundeservice.1881.no/hc/no/requests/new" target="_blank">kontakt kundeservice</a> hvis du trenger hjelp til å gjøre endringer.
              </p>
            )}

            {companyOptions.length > 1 ? (
              companyOptions.map(company => (
                <div className="form-check mb-3" key={company.id}>
                    <input className="form-check-input" type="radio" name="companySelect" id={`company-${company.id}`} onChange={handleRadioChange} value={company.id}></input>
                    <label className="form-check-label" htmlFor={`company-${company.id}`}>
                      {company.name}. {company.location.streetName} {company.location.houseNumber}{company.location.houseLetter}
                      {company.location.streetName !== null ? "," : ""} {company.location.postalCode} {company.location.postalArea}
                      <br />
                      <span className="text-secondary">
                        {company.legalName !== null && company.name !== company.legalName ? `Juridisk navn: ${company.legalName}` : null}
                      </span>
                    </label>
                  </div>
              ))
            ) : currentCompany ? (
              <div className="mb-3">
                <p className="mb-0">
                  {currentCompany.name}. {currentCompany.location.streetName} {currentCompany.location.houseNumber}
                  {currentCompany.location.houseLetter}
                  {currentCompany.location.streetName ? "," : ""} {currentCompany.location.postalCode} {currentCompany.location.postalArea} {currentCompany.legalName && currentCompany.name !== currentCompany.legalName ? `Juridisk navn: ${currentCompany.legalName}` : null}
                </p>
              </div>
            ) : null}

            <p className="mt-4">
              <button type="submit" disabled={isSumbitDisabled} className="btn btn-primary">
                Gå videre
                {(loadingSearch || loadingSubmit) && (
                  <span className="spinner-border spinner-border-sm ms-2"></span>
                )}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary ms-2"
                onClick={() => navigate(-1)}
              >
                Avbryt
              </button>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCompany;
